export const UNITS_KEY = 'showUnitSystemForDashboard-';
export const TIMEZONE_KEY = 'showTimezoneForDashboard-';
export const RECENT_ASSETS_KEY = 'AssetConfigurator:recentAssets';
export const DASHBOARDS_DRAWER_MENU_STATE_KEY = 'dashboards-drawer-menu-state';
export const ALERTS_PAGE_UI_STORAGE = 'alerts-page-ui-storage';
export const ALERTS_PAGE_FILTER_STORAGE = 'alerts-page-filter-storage';
export const ALERTS_PAGE_ASSETS_FILTER_STORAGE = 'alerts-page-assets-filter-storage';
export const OPEN_ALERT_DETAILS_ID = 'openAlertDetailsId';
export const FRAC_FLEET_COST_BRACKETS_ACCORDIONS_STATE_KEY =
  'frac-fleet-cost-brackets-accordions-state';
